import React, { useEffect, useState } from 'react';
import CustomDialog from 'components/CustomDialog/CustomDialog';
import { useDispatch } from 'react-redux';
import { hideLoadingIndicator, showLoadingIndicator } from 'redux/modules/api/loadingIndicator/actions';
import { ActivitiesService } from 'services/activities/activities';
import { finalize } from 'rxjs/operators';
import { throwError } from 'rxjs';
import GridContainer from 'components/Grid/GridContainer';
import TechnicalInformationCard from './subcomponents/TechnicalInformationCard';
import EventDetailsCard from './subcomponents/EventDetailsCard';
import AccountInformationCard from './subcomponents/AccountInformationCard';
import { translate } from 'components/Translation';
import { SingleInteractionLog } from 'utils/api/models/activities/interactionDetailsResponse';

interface IActivityDetailsProps {
	interactionId: number | null;
	isOpen: boolean;
	turnOffDialog: () => void;
}

const ActivityDetailsDialog = ({ interactionId, isOpen, turnOffDialog }: IActivityDetailsProps) => {
	const dispatch = useDispatch();

	const [interactionInfo, setInteractionInfo] = useState<SingleInteractionLog | null>();
	const [isInteractionDetailsLoading, setIsInteractionDetailsLoading] = useState<boolean>(true);
	const [areEventsLoading, setAreEventsLoading] = useState<boolean>(true);

	const hideDialog = () => {
		setInteractionInfo(null);
		turnOffDialog();
	};

	useEffect(() => {
		if (interactionId) {
			setIsInteractionDetailsLoading(true);
			dispatch(showLoadingIndicator());
			setAreEventsLoading(true);
			ActivitiesService.getInteractionDetails(+interactionId)
				.pipe(finalize(() => dispatch(hideLoadingIndicator())))
				.subscribe(
					({ response }) => {
						setInteractionInfo(response);
						setIsInteractionDetailsLoading(false);
					},
					(error) => throwError(error)
				);
		}
	}, [interactionId, dispatch]);

	return (
		<CustomDialog
			header={translate('activities.details.activity.details')}
			isOpen={isOpen}
			hideDialog={hideDialog}
			loading={isInteractionDetailsLoading || areEventsLoading}
			width={588}
			dialogBody={
				<div style={{ overflowX: 'hidden' }}>
					<GridContainer justify="flex-start">
						<AccountInformationCard
							accountType={interactionInfo?.account.type}
							billingType={interactionInfo?.account.billingType}
							number={interactionInfo?.account.number}
							accountId={interactionInfo?.account.id}
							dst={interactionInfo?.dst}
							eventCode={interactionInfo?.eventCode}
							src={interactionInfo?.src}
						/>
						<EventDetailsCard
							eventCode={interactionInfo?.eventCode}
							amount={interactionInfo?.amount}
							src={interactionInfo?.src}
							target={interactionInfo?.dst}
							setLoading={setAreEventsLoading}
						/>
					</GridContainer>
				</div>
			}
		/>
	);
};

export default ActivityDetailsDialog;
